import { Typography, Space as AntSpace } from 'antd';
import styled from 'styled-components';
import {
  HelperText01,
  ProductiveHeading05,
  ProductiveHeading07,
} from 'components/styles';

type Type = 'success' | 'error';

const { Text, Paragraph, Link } = Typography;
const colorMap = {
  success: 'var(--green-50)',
  error: 'var(--red-60)',
  default: 'var(--gray-70)',
};

export const Title = styled(Text)`
  ${ProductiveHeading07};

  color: var(--gray-80);
`;

export const TitleHelper = styled(Title)`
  font-weight: normal;
`;

export const Description = styled(Paragraph)<{ color?: Type }>`
  ${HelperText01};

  color: ${({ color }) => colorMap[color ?? 'undefined']};
`;

export const Space = styled(AntSpace).attrs({ direction: 'vertical' })``;

export const LinkText = styled(Link)`
  ${ProductiveHeading05};
`;
